import React from 'react'
import Navbar from '../Home/Navbar'
import Footer from '../Home/Footer'
import AuthModal from '../Auth/AuthModal.jsx'
import { useLocation } from "react-router-dom";
import Booklet from '../Home/Booklet.jsx';
import ItemsForCatalogs from '../Home/ItemsForCatalogs.jsx';
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from "react-router-dom";


function CatalogDetails({selectedArea, setSelectedArea , isLoggedIn, setIsLoggedIn , setShowAuthModal , showAuthModal}) {
   const { state: catalog } = useLocation();
   const navigate = useNavigate();

  return (
    <div className='min-h-screen flex flex-col'>
      <Navbar
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        onLoginClick={() => setShowAuthModal(true)}
      />
      <div className='p-4'>
      <button onClick={() => navigate(`/`)}>
        <ArrowLeft size={20} />
      </button>
      </div>
      <div className="flex-1 overflow-hidden flex flex flex-col p-4">
      
        <div className="h-full h-[100vh]">

              <Booklet
          catalogueUrl={
            catalog.catalogueImageUrl ??
            catalog.latestCatalogue?.catalogueImageUrl
          }
        />
        </div>
      <div className='p-4'>
        <ItemsForCatalogs offerHeaderId={
            catalog.latestOffer?.id ??
            147
        }/>
      </div>

        </div>

      
        {showAuthModal && (
          <AuthModal
            onClose={() => setShowAuthModal(false)}
            setIsLoggedIn={setIsLoggedIn}
          />
        )}
      <Footer/>
    </div>
  )
}

export default CatalogDetails
